import { DeleteOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select, Tooltip } from "antd";
import React from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "./AreaManagerCard.less";

export const AreaManagerCard = ({
  id,
  deleteManager,
  form,
  count,
  locationList,
}) => {
  return (
    <div className="areaManagerCard">
      <div className="managerNumber">{id + 1}</div>
      {/* {count > 1 && (
        <div className="deleteManager">
          <Button
            type="link"
            shape="circle"
            danger
            icon={<DeleteOutlined />}
            onClick={() => deleteManager(id)}
          />
        </div>
      )} */}
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <Tooltip
            trigger={["focus"]}
            title="Employee Code"
            placement="topLeft"
            overlayClassName="numeric-input"
          >
            <Form.Item
              name={`employee_code_${id}`}
              rules={[
                {
                  required: true,
                  message: "Employee Code is required",
                  whitespace: true,
                },
              ]}
            >
              <Input name="code" placeholder="Employee Code" />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Tooltip
            trigger={["focus"]}
            title="First Name"
            placement="topLeft"
            overlayClassName="numeric-input"
          >
            <Form.Item
              name={`firstName_${id}`}
              rules={[
                {
                  required: true,
                  message: "First Name is required",
                  whitespace: true,
                },
                {
                  pattern: new RegExp(
                    "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                  ),
                  message: "Invalid First name",
                },
              ]}
            >
              <Input name="firstname" placeholder="First Name" />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Tooltip
            trigger={["focus"]}
            title="Last Name"
            placement="topLeft"
            overlayClassName="numeric-input"
          >
            <Form.Item
              name={`lastName_${id}`}
              rules={[
                {
                  required: true,
                  message: "Last Name is required",
                  whitespace: true,
                },
                {
                  pattern: new RegExp(
                    "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                  ),
                  message: "Invalid Last name",
                },
              ]}
            >
              <Input name="lastname" placeholder="Last Name" />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Tooltip
            trigger={["focus"]}
            title="Email"
            placement="topLeft"
            overlayClassName="numeric-input"
          >
            <Form.Item
              name={`email_${id}`}
              rules={[
                {
                  required: true,
                  message: "Email Address is required",
                  whitespace: true,
                },
                {
                  type: "email",
                  message: "Enter Valid Email Address",
                },
              ]}
            >
              <Input name="email" placeholder="Email" />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Tooltip
            trigger={["focus"]}
            title="Phone"
            placement="topLeft"
            overlayClassName="numeric-input"
          >
            <Form.Item
              name={`phone_${id}`}
              rules={[
                {
                  required: true,
                  message: "Phone Number is required",
                  whitespace: true,
                },
                () => ({
                  validator(_, value) {
                    if (value && isValidPhoneNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Enter Valid Phone Number")
                    );
                  },
                }),
              ]}
            >
              <PhoneInput
                className="phoneInput_blk"
                defaultCountry="US"
                placeholder="(201) 555-1234"
                countryOptionsOrder={["US","CA","|","..."]}
              />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            name={`locations_${id}`}
            rules={[
              {
                required: true,
                message: "Please select atleast one location",
                type: "array",
              },
            ]}
          >
            <Select
              mode="multiple"
              placeholder="Please select locations"
              className="locationSelect"
              maxTagCount="responsive"
            >
              {locationList.map(({location_id, location_name}, index) => {
                return (
                  <Select.Option value={location_id} key={location_id}>
                    {location_name}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item className="d-none" name={`user_id_${id}`}></Form.Item>
    </div>
  );
};
